import { useEffect, useRef } from "react"

const useSomeChangedEffect = (fn, inputs = [], changeChecked = []) => {
	const previousInputsRef = useRef([...changeChecked])
  
	useEffect(() => {
		if(changeChecked.some((value, index) => value !== previousInputsRef.current[index])) {
			fn(inputs)
		}
	 	previousInputsRef.current = [...changeChecked]
	}, inputs)
  }

export default useSomeChangedEffect